module.exports = __webpack_public_path__ + "img/04.9da9dfef.jpg";